import React from "react";

type MascotState =
  | "idle"
  | "thinking"
  | "listening"
  | "disappointed"
  | "strict"
  | "approving"
  | "teaching"
  | "maintenance"
  | "waiting"
  | "rate_limited";

export type { MascotState };

interface MascotProps {
  state: MascotState;
  size?: "small" | "medium" | "large";
  className?: string;
  alt?: string;
}

const MASCOT_MAP: Record<MascotState, string> = {
  idle: "/assets/mascot/mascot-idle.svg",
  thinking: "/assets/mascot/mascot-thinking.svg",
  listening: "/assets/mascot/mascot-listening.svg",
  disappointed: "/assets/mascot/mascot-disappointed.svg",
  strict: "/assets/mascot/mascot-strict.svg",
  approving: "/assets/mascot/mascot-approving.svg",
  teaching: "/assets/mascot/mascot-teaching.svg",
  maintenance: "/assets/mascot/mascot-maintenance.svg",
  waiting: "/assets/mascot/mascot-waiting.svg",
  rate_limited: "/assets/mascot/mascot-rate-limited.svg",
};

const SIZE_MAP: Record<"small" | "medium" | "large", number> = {
  small: 32,
  medium: 64,
  large: 120,
};

export function Mascot({
  state,
  size = "medium",
  className = "",
  alt,
}: MascotProps) {
  const src = MASCOT_MAP[state];
  const dimension = SIZE_MAP[size];
  return (
    <div
      className={`inline-flex items-center justify-center bg-card dark:bg-muted border border-border relative z-0 ${className}`}
      style={{ width: dimension, height: dimension }}
    >
      <img
        src={src}
        alt={alt ?? `Mascot: ${state}`}
        width={dimension}
        height={dimension}
        className="w-full h-full p-1 object-contain"
      />
    </div>
  );
}
